import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { getEnvValue } from '../../Helper/env';
import { DrawerNavigationProp } from '@react-navigation/drawer';
import { useNavigation } from '@react-navigation/native';

import FloatingButtonBottom from '../../Components/FloatingButtonBottom';
import FloatingContentShopMealPlanCart from '../../Components/FloatingButtonBottom/ShopMealPlanCart';
import useMealPlan from '../../Hooks/useMealPlan';
import { selectHasMealPlanItem } from '../../RTK/mealPlan/selectors';
import { shopLoadingSelector } from '../../RTK/shop/selectors';

type DrawerNavProps = DrawerNavigationProp<{ openDrawer: () => void }>;
const RAZZLE_BUILD_MODE = getEnvValue('RAZZLE_BUILD_MODE');
const isBranded = RAZZLE_BUILD_MODE === 'branded';
const FloatingButtonMobileView = () => {
  const navigation = useNavigation();
  const hideFloatingOnlargeScreen = useMediaQuery({
    query: '(min-width: 1400px)',
  });
  const { isMealPlan } = useMealPlan();
  const hasMealPlanItem = useSelector(selectHasMealPlanItem);
  const shopLoading = useSelector(shopLoadingSelector);
  const showMealPlanFloating = isMealPlan && hasMealPlanItem;

  const _onMealPlanPress = () => {
    const nav = (
      isBranded ? navigation : navigation.getParent()
    ) as DrawerNavProps;
    nav?.openDrawer?.();
  };

  if (hideFloatingOnlargeScreen) return null;

  return (
    <FloatingButtonBottom
      visible={showMealPlanFloating && !shopLoading}
      onPress={_onMealPlanPress}
      plain
    >
      <FloatingContentShopMealPlanCart />
    </FloatingButtonBottom>
  );
};

export default FloatingButtonMobileView;
